export const getModeClass = ({ error, touched, active, submitting, validating, disabled, readOnly }) => {
    if (submitting || validating || disabled || readOnly) {
        return 'disabled';
    }

    if (active) {
        return 'focus';
    }

    if (!touched) {
        return '';
    }

    return error ? 'invalid' : 'valid';
};
